import {ZM_CREATE_TYPE, ADD_ON_TYPE} from './consts';

import {isCciCalendar} from 'Utils';

/**
 * Try to read event's zmCreateEventType enum and convert to addOnType enum
  event: {
    ...
    "shared": {
        "ZOOM_ConferenceNumber": "999999999",
        "ZOOM_ConferencePassword": "012345",
        "zmCreateEventType": "1", <-- Convert to addOnType enum
        "zmMeetingNum": "999999999"
    }
  }
 * @param {Object} serverEvent
 * @return {String}
 */

export const getEventAddOnType = (serverEvent) => {
  // new multiple location field
  if (serverEvent?.locationKind) {
    return serverEvent.locationKind;
  }
  let addOnType = '';
  const zmMeetingType = serverEvent?.extendedProperties?.shared?.zmCreateEventType;
  switch (zmMeetingType) {
    case ZM_CREATE_TYPE.ZOOM_MEETING:
      addOnType = ADD_ON_TYPE.ZOOM_MEETING;
      break;
    case ZM_CREATE_TYPE.ZOOM_PHONE:
      addOnType = ADD_ON_TYPE.ZOOM_PHONE;
      break;
    default:
      addOnType = ADD_ON_TYPE.OFFLINE;
      break;
  }
  return addOnType;
};

export const isOutboundCallEvent = (serverEvent) => {
  return getEventAddOnType(serverEvent) === ADD_ON_TYPE.OUT_BOUND_CALL && serverEvent?.location;
};

/**
 * Helper function to parse appointment location values
 * e.g. 'Example Location;https://zoom.us/j/123456' -> 'Example Location'
 * @param {String} text
 * @param {String} meetingType
 * @return {String}
 */

export const parseLocation = (text, meetingType) => {
  if (meetingType === ADD_ON_TYPE.ZOOM_MEETING || meetingType === ADD_ON_TYPE.ZOOM_PHONE) {
    if (text?.includes(';')) {
      return text?.slice(0, text?.lastIndexOf(';'));
    }
    // No actual location was provided; only conference links
    return '';
  }
  // If offline, return location literally
  return text;
};

/**
 * format query object to event info
 * @param {Object} eventInfo
 * @param {?Function} getEventBookerInfo
 * @return {Object}
 */
export function formatEventInfo(eventInfo, getEventBookerInfo) {
  const bookers = eventInfo.attendees.reduce((previous, current) => {
    if (current.booker) {
      previous.push({
        email: current.email,
        firstName: current?.firstName,
        lastName: current?.lastName,
        name: current.displayName,
        phoneNumber: current.phoneNumber,
        responseStatus: current.responseStatus,
      });
    }
    return previous;
  }, []);

  let summary = '(No title)';
  if (eventInfo.summary !== undefined) {
    summary = eventInfo.summary;
  }

  const addOnType = getEventAddOnType(eventInfo);
  const location = parseLocation(eventInfo.location, addOnType);

  let bookerInfo;
  if (getEventBookerInfo) {
    bookerInfo = getEventBookerInfo(eventInfo);
  }

  const formatted = {
    eventId: eventInfo.id,
    assignedTo: eventInfo.assignedTo,
    appointmentId: eventInfo.appointmentId,
    bookingMethod: eventInfo?.bookingMethod,
    summary,
    bookers,
    location,
    addOnType,
    timeZone: eventInfo.start.timeZone,
    status: eventInfo.status,
    hostEmail: eventInfo.organizer?.email,
    attendees: eventInfo.attendees,
    bookerInfo: bookerInfo,
    originalEvent: eventInfo,
    hostDisplayName: eventInfo?.assignedTo?.[0] || '',
    guests: (!!eventInfo?.guests?.length) ?
      eventInfo?.guests?.map((guest) => guest.email) :
      [],
    isCciEvent: eventInfo.hostType === 'cci' || isCciCalendar(eventInfo?.organizer?.email),
    fromSingleUseLink: eventInfo?.fromSingleUseLink ?? false,
    trackingParams: eventInfo?.trackingParams || {},
  };
  return formatted;
}

